import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ActivationEnd, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {LangChangeEvent, TranslateModule, TranslateService} from '@ngx-translate/core';
import {FactoryIdToCountryMapper} from './feature/services/factory-id-to-country-mapper';
import {MaintenanceBannerComponent} from './shared/components/maintenance-banner/maintenance-banner.component';
import {MatSidenavContainer, MatSidenavContent} from "@angular/material/sidenav";
import {MatToolbar} from "@angular/material/toolbar";
import {GlobalSpinnerComponent} from "./shared/components/global-spinner/global-spinner.component";
import {SplashScreenComponent} from "./shared/components/splash-screen/splash-screen.component";
import {DswFooterComponent} from "@vi-succ/design-system-web";
import {HeaderComponent} from "./shared/components/header/header.component";
import {NgIf} from "@angular/common";
import {SplashScreenStateService} from "./shared/components/splash-screen/splash-screen-state.service";
import {NavigationService} from "./core/services/navigation.service";
import {EmbedModeService} from "./feature/services/embed-mode.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [MaintenanceBannerComponent, RouterOutlet, TranslateModule, MatSidenavContent, MatSidenavContainer, MatToolbar, GlobalSpinnerComponent, SplashScreenComponent, DswFooterComponent, HeaderComponent, NgIf]
})
export class AppComponent implements OnInit {

  public embedModeEnabled: boolean = false;
  accessibilityUrl = 'https://legal-policies.viessmann-climatesolutions.com/b2c/appointment-booking/accessibility.html'

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService,
    private splashScreenStateService: SplashScreenStateService,
    private factoryIdToCountryMapper: FactoryIdToCountryMapper,
    private navigationService: NavigationService,
    private embedModeService: EmbedModeService,
  ) {
  }

  ngOnInit(): void {

    this.navigationService.init(); // init in root component to fetch all states
    const htmlTag = document.documentElement; // HTML-Tag
    htmlTag.setAttribute('lang', navigator.language);

    this.router.events.subscribe(event => {
      if (event instanceof ActivationEnd && event.snapshot.params['factoryId'] && event.snapshot.params['language']) {
        const country: string = this.factoryIdToCountryMapper.getCountry(event.snapshot.params['factoryId']) || 'DE';
        const language: string = event.snapshot.params['language'].toLowerCase();
        const locale: string = language + '-' + country;
        if (this.translateService.currentLang != locale) {
          this.translateService.use(locale);
          console.log('Using following locale for translations: ' + locale);
        }
      }

      // hide splash screen
      if (event instanceof NavigationEnd) {
        this.splashScreenStateService.stop();
      }
    });

    // set title and html lang attribute
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.translateService.get('app.title').subscribe((res: string) => {
        this.titleService.setTitle(res);
      });
      const htmlTag = document.documentElement; // HTML-Tag
      htmlTag.setAttribute('lang', event.lang);
    });

    // check embed mode
    this.route.queryParams.subscribe(params => {
      const embedMode = params['embedMode'];
      if (embedMode) {
        this.embedModeService.setEmbedMode(embedMode);
        this.embedModeEnabled = this.embedModeService.isEmbedModeEnabled();
      }
    });

  }
}


